const NOTIFY_ME_ENABLED = false; // Toggle Klaviyo Notify Me

const createGalleryManager = (containerEl) => {
    const mainSwiperEl = containerEl.querySelector("#PDPMainGallery");
    const thumbSwiperEl = containerEl.querySelector("#PDPThumbGallery");
    const template = containerEl.querySelector("#PDPMediaTemplate");
    const nextBtn = containerEl.querySelector(".custom-thumb-next");
    const prevBtn = containerEl.querySelector(".custom-thumb-prev");

    let mainSwiper = null;
    let thumbSwiper = null;
    let allSlides = [];

    if (template && mainSwiperEl) {
        allSlides = Array.from(template.content.querySelectorAll(".swiper-slide"));
        
        thumbSwiper = new Swiper(thumbSwiperEl, {
            slidesPerView: "auto",
            spaceBetween: 8,
            freeMode: true,
            watchSlidesProgress: true,
            watchOverflow: true,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            on: {
                init: function () {
                    containerEl.classList.add("swiper-navigation-ready"); 
                }
            },
        });

        mainSwiper = new Swiper(mainSwiperEl, {
            slidesPerView: 1,
            effect: "fade",
            speed: 300,
            fadeEffect: { crossFade: true },
            thumbs: { swiper: thumbSwiper },
            on: {
                slideChangeTransitionStart: function () {
                    const prevIndex = this.previousIndex;
                    if (prevIndex == null) return;

                    const prevSlide = this.slides[prevIndex];
                    if (!prevSlide) return;

                    prevSlide.querySelectorAll("video").forEach((v) => {
                        v.pause();
                        v.currentTime = 0;
                    });
                    prevSlide.querySelectorAll("iframe").forEach((i) => {
                        i.src = i.src;
                    });
                },
            },
        });

        window.addEventListener("load", () => {
            setTimeout(() => {
                thumbSwiper?.update();
                mainSwiper?.update();
            }, 100);
        });
    }

    const findSlidesByVariantId = (variantId) => {
        return allSlides.filter((slide) => slide.dataset.variantId === variantId.toString());
    };

    const renderSlides = (slides) => {
        const mainSlides = [];
        const thumbSlides = [];

        slides.forEach((slide) => {
            const mainSlide = document.createElement("div");
            mainSlide.className = "swiper-slide";
            mainSlide.appendChild(slide.querySelector('[data-target="main"]').cloneNode(true));
            mainSlides.push(mainSlide);

            const thumbSlide = document.createElement("div");
            thumbSlide.className = "swiper-slide";
            thumbSlide.appendChild(slide.querySelector('[data-target="thumb"]').cloneNode(true));
            thumbSlides.push(thumbSlide);
        });

        mainSwiper.removeAllSlides();
        thumbSwiper.removeAllSlides();

        mainSwiper.appendSlide(mainSlides);
        thumbSwiper.appendSlide(thumbSlides);

        mainSwiper.slideTo(0, 0, false);
        thumbSwiper.slideTo(0, 0, false);

        thumbSwiper.update();
        mainSwiper.update();
    };

    const updateGallery = (variant) => {
        if (!variant || !allSlides.length || !mainSwiper || !thumbSwiper) return;

        let matchingSlides = findSlidesByVariantId(variant.id);

        if (matchingSlides.length === 0) {
            const fallbackVariantId = allSlides[0]?.dataset.variantId;
            matchingSlides = fallbackVariantId ? findSlidesByVariantId(fallbackVariantId) : allSlides;
        }

        renderSlides(matchingSlides);
    };

    return { updateGallery };
};

const createUIManager = (containerEl, data) => {
    const optionSelectors = containerEl.querySelectorAll(".pdp-option-selector");
    const reviewSummary = containerEl.querySelector("#bv-rating-summary");
    const reviewContainer = document.getElementById("bv-reviews");
    const priceEls = containerEl.querySelectorAll("[data-actual-price]");
    const comparePriceEls = containerEl.querySelectorAll("[data-compare-price]");
    const savePriceWrappers = containerEl.querySelectorAll(".price-inner-details .product-save-price");
    const savePriceEls = containerEl.querySelectorAll("[data-save-price]");
    const buyButtons = containerEl.querySelectorAll("[data-buyButton]");
    const pdpAcceleratedBtnEl = containerEl.querySelectorAll(".pdp-accelerated-btn");
    const variantInputs = document.querySelectorAll(
        `.pdp-top-sticky-bar .form-variant-id-${data.product.id}, .new-pdp-layout-section .form-variant-id-${data.product.id}, .payment-options-variant`
    );

    const pdpBarEl = document.querySelector(".pdp-top-sticky-bar");
    const pdpBarBuyButtonEl = pdpBarEl?.querySelector("[data-buyButton]");
    const pdpBarActualPriceEl = pdpBarEl?.querySelector("[data-actual-price]");
    const pdpBarComparePriceEl = pdpBarEl?.querySelector("[data-compare-price]");
    const pdpBarBuyButtonTextEl = pdpBarBuyButtonEl ? Array.from(pdpBarBuyButtonEl.querySelectorAll("[data-buyButtonText]")) : [];


    // NEW: resolve preorder status per variant — product-level true wins outright,
    // otherwise fall back to that specific variant's own flag.
    const getPreorderState = (variant) => {
        if (data.productPreorder === true) return true;
        const map = data.variantPreorderMap || {};
        return map[variant.id] === true;
    };


    const calculatePricingData = (variant, closedShop = null) => {
        const actualPrice = closedShop ? closedShop.closed_shop_price : variant.price;
        const comparePrice = closedShop ? closedShop.compare_price : variant.compare_at_price;
        const showCompare = comparePrice && comparePrice > actualPrice;

        return {
            productActualPrice: Utils.formatMoney(actualPrice),
            productCompareAtPrice: comparePrice ? Utils.formatMoney(comparePrice) : null,
            showCompare,
            saveAmount: showCompare ? Utils.formatMoney(comparePrice - actualPrice) : null,
        };
    };

    const updateStandardPrices = ({ productActualPrice, productCompareAtPrice, showCompare, saveAmount }) => {
        priceEls.forEach((el) => (el.textContent = productActualPrice));

        comparePriceEls.forEach((el) => {
            el.style.display = showCompare ? "inline-block" : "none";
            if (showCompare) el.textContent = productCompareAtPrice;
        });

        savePriceWrappers.forEach((el) => {
            el.classList.toggle("display-hidden", !showCompare);
        });

        if (showCompare && saveAmount) {
            savePriceEls.forEach((el) => (el.textContent = saveAmount));
        }
    };

    const updateBuyButtons = (isVariantAvailable, isPreorder) => {
            const isComingSoon = data.comingSoon;
            // const availableButtonText = data.preorder ? 'Preorder' : data.buyNowText || "Add to Cart";
            const availableButtonText = isPreorder ? 'Preorder' : data.buyNowText || "Add to Cart";
             
            let buttonText = "Not available";
            console.log("from preorder ", availableButtonText,data.preorder);

            if (isComingSoon) {
                buttonText = "Coming Soon";
            } else if (isVariantAvailable) {
                            console.log("from preorder 22", availableButtonText, data.preorder);

                buttonText = availableButtonText;
            } else if (NOTIFY_ME_ENABLED) {
                buttonText = data.notifyMeText || "Notify Me";
            }

            const isDisabled = isComingSoon || (!isVariantAvailable && !NOTIFY_ME_ENABLED);
            const showKlaviyoNotifyMe = !isComingSoon && !isVariantAvailable && NOTIFY_ME_ENABLED;

            buyButtons.forEach((btn) => {
                btn.querySelectorAll("[data-buyButtonText]").forEach((textEl) => {
                    textEl.textContent = buttonText;
                });

                // NEW: keep the data-addToCartText attribute in sync too,
                // so any code that resets label from this attribute (e.g. after
                // "Added!" animation) doesn't revert to a stale value.
                const textWrapper = btn.querySelector(".add-to-cart-text");
                if (textWrapper) {
                    textWrapper.setAttribute("data-addToCartText", buttonText);
                }

                btn.disabled = isDisabled;
                
                if (isComingSoon) return;

                btn.classList.toggle("klaviyo-bis-trigger", showKlaviyoNotifyMe);
            });
    };

    const updateAcceleratedCheckout = (isVariantAvailable) => {
        pdpAcceleratedBtnEl.forEach((el) => {
            el.style.display = isVariantAvailable ? "flex" : "none";
        });
    };

    const updateStickyBar = (isVariantAvailable, { productActualPrice, productCompareAtPrice, showCompare } , isPreorder) => {
        if (!pdpBarEl) return;

        if (pdpBarBuyButtonEl && !data.comingSoon) {
            let buttonText = "Not available";
            let isDisabled = true;
            let showKlaviyo = false;

            if (isVariantAvailable) {
                // buttonText = data.preorder ? 'Preorder' : (data.buyNowText || "Add to Cart");
                buttonText = isPreorder ? 'Preorder' : (data.buyNowText || "Add to Cart");
                 
                isDisabled = false;
            } else if (NOTIFY_ME_ENABLED) {
                buttonText = data.notifyMeText || "Notify Me";
                isDisabled = false;
                showKlaviyo = true;
            }

            pdpBarBuyButtonTextEl.forEach((el) => (el.textContent = buttonText));
            pdpBarBuyButtonEl.disabled = isDisabled;
            pdpBarBuyButtonEl.classList.toggle("klaviyo-bis-trigger", showKlaviyo);
        }

        if (pdpBarActualPriceEl) {
            pdpBarActualPriceEl.textContent = productActualPrice;
        }

        if (pdpBarComparePriceEl) {
            pdpBarComparePriceEl.style.display = showCompare ? "inline-block" : "none";
            if (showCompare) {
                pdpBarComparePriceEl.textContent = productCompareAtPrice;
            }
        }
    };

    const updateReviews = (variant) => {
        [reviewSummary, reviewContainer].forEach((el) => {
            if (el && el.getAttribute("data-bv-product-id") !== variant.sku) {
                el.setAttribute("data-bv-product-id", variant.sku);
            }
        });
    };

    const updateURLAndInputs = (variantId) => {
        variantInputs.forEach((el) => (el.value = variantId));
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variantId);
        window.history.replaceState({}, "", url);
    };

    const updateClosedShopFields = (closedShop, pricelist) => {
        const toggleFields = (selector, val) => {
            document.querySelectorAll(selector).forEach((el) => {
                el.value = val;
                el.disabled = false;
            });
        };

        toggleFields(".closed_shop_pricelist", pricelist);
        toggleFields(".closed_shop_price", closedShop.closed_shop_price);
        toggleFields(".closed_shop_token", closedShop.closed_shop_token);

        const addPromotionalLabel = (selector) => {
            document.querySelectorAll(selector).forEach((el) => {
                const next = el.nextElementSibling;
                if (!next || !next.classList.contains("promotional-price")) {
                    el.insertAdjacentHTML("afterend", '<p class="promotional-price">Promotional price</p>');
                }
            });
        };

        addPromotionalLabel(".pdp-top-sticky-bar .product-price[data-variant-id]");
        addPromotionalLabel(".new-pdp-layout-section .price-inner[data-variant-id]");
    };

    const clearClosedShopFields = () => {
        const resetFields = (selector) => {
            document.querySelectorAll(selector).forEach((el) => {
                el.value = "";
                el.disabled = true;
            });
        };

        resetFields(".closed_shop_pricelist");
        resetFields(".closed_shop_price");
        resetFields(".closed_shop_token");
        document.querySelectorAll(".promotional-price").forEach((el) => el.remove());
    };

    const updateSelectedOptionLabels = (currentOptions) => {
        Object.entries(currentOptions).forEach(([optionKey, targetValue]) => {
            const labelElement = containerEl.querySelector(`[data-pdp-label="${optionKey}"]`);
            if (labelElement) {
                labelElement.textContent = targetValue || "";
                labelElement.style.setProperty("display", "inline", "important");
                labelElement.style.setProperty("visibility", "visible", "important");
                labelElement.style.setProperty("opacity", "1", "important");

                const parentRow = labelElement.closest(".pdp-isolated-label-row");
                if (parentRow) {
                    parentRow.style.setProperty("display", "block", "important");
                    parentRow.style.setProperty("visibility", "visible", "important");
                    parentRow.style.setProperty("opacity", "1", "important");
                }
            }
        });
    };

    const updateOptionButtonStates = (currentOptions, validVariants, dominantOptionKey) => {
        optionSelectors.forEach((el) => {
            const key = el.dataset.optionIndex;
            const val = el.dataset.value;

            el.classList.toggle("active", currentOptions[key] === val);

            let optionValid = true;
            if (key !== dominantOptionKey) {
                optionValid = validVariants.some(
                    (v) => v[dominantOptionKey] === currentOptions[dominantOptionKey] && v[key] === val
                );
            }
            el.classList.toggle("disabled-option", !optionValid);
        });
    };

    return {
        updateUI: (variant) => {
            if (!variant) return;

            const pricelist = typeof getCookie === "function" ? getCookie("pricelist") : null;
            const closedShop = typeof benefits !== "undefined" ? benefits?.[variant.id]?.[pricelist] : null;

            const pricingData = calculatePricingData(variant, closedShop);

            const isPreorder = getPreorderState(variant); // NEW: recomputed per active variant

            if (window.hideKlaviyoInjectedButton) window.hideKlaviyoInjectedButton();
            
            updateStandardPrices(pricingData);
            updateBuyButtons(variant.available,isPreorder);
            updateAcceleratedCheckout(variant.available);
            updateStickyBar(variant.available, pricingData, isPreorder);
            updateReviews(variant);
            updateURLAndInputs(variant.id);

            if (closedShop) {
                updateClosedShopFields(closedShop, pricelist);
            } else {
                clearClosedShopFields();
            }
        },
        updateActiveSelectors: (currentOptions, validVariants, dominantOptionKey) => {
            updateOptionButtonStates(currentOptions, validVariants, dominantOptionKey);
            updateSelectedOptionLabels(currentOptions);
            
            const optionsContainer = containerEl.querySelector("#DynamicOptionsContainer");
            if (optionsContainer) optionsContainer.classList.remove("pdp-loading");
        }
    };
};

const createVariantManager = (containerEl, data, onVariantChange) => {
    const variants = data.variants;
    const optionsMap = data.optionsWithValues || [];
    const dominantOptionKey = optionsMap.length > 0 ? `option${optionsMap[0].position}` : "option1";
    
    let activeVariant = null;
    let currentOptions = { option1: null, option2: null, option3: null };

    const isVariantLaunched = (variant) => {
        const launchDate = data.variantLaunchDates?.[variant.id];
        if (!launchDate) return true;
        const today = new Date().toISOString().split("T")[0];
        return launchDate <= today;
    };

    const getInitialVariant = (defaultVariantId) => {
        const urlVariant = new URLSearchParams(window.location.search).get("variant");
        
        const urlMatch = variants.find((v) => v.id == urlVariant && isVariantLaunched(v));
        if (urlMatch) return urlMatch;

        const defaultMatch = variants.find((v) => v.id === defaultVariantId && isVariantLaunched(v));
        if (defaultMatch) return defaultMatch;

        return variants.find(isVariantLaunched);
    };

    const isPerfectMatch = (variant) => {
        return (
            (!currentOptions.option1 || variant.option1 === currentOptions.option1) &&
            (!currentOptions.option2 || variant.option2 === currentOptions.option2) &&
            (!currentOptions.option3 || variant.option3 === currentOptions.option3)
        );
    };

    const triggerChange = () => {
        onVariantChange(activeVariant, currentOptions, variants, dominantOptionKey);
    };

    const findMatchingVariant = () => {
        let matched = variants.find(isPerfectMatch);

        if (!matched) {
            matched = variants.find((v) => v[dominantOptionKey] === currentOptions[dominantOptionKey]);
            if (matched) {
                currentOptions.option1 = matched.option1;
                currentOptions.option2 = matched.option2;
                currentOptions.option3 = matched.option3;
            }
        }

        if (matched) {
            activeVariant = matched;
            triggerChange();
        }
    };

    activeVariant = getInitialVariant(data.defaultVariantId);
    if (activeVariant) {
        currentOptions = {
            option1: activeVariant.option1,
            option2: activeVariant.option2,
            option3: activeVariant.option3,
        };
    }

    containerEl.addEventListener("click", (e) => {
        const selector = e.target.closest(".pdp-option-selector");
        if (!selector || selector.classList.contains("disabled-option")) return;

        const optIndex = selector.dataset.optionIndex;
        const optValue = selector.dataset.value;

        currentOptions[optIndex] = optValue;
        findMatchingVariant();
    });

    if (activeVariant) triggerChange();
};

const initPDP = (containerEl) => {
    if (!window.PDPData) return;

    const galleryManager = createGalleryManager(containerEl);
    const uiManager = createUIManager(containerEl, window.PDPData);

    createVariantManager(containerEl, window.PDPData, (variant, options, allVariants, dominantKey) => {
        galleryManager.updateGallery(variant);
        uiManager.updateUI(variant);
        uiManager.updateActiveSelectors(options, allVariants, dominantKey);
    });
};

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".new-pdp-layout-section").forEach((el) => {
        initPDP(el);
    });
});